export default "https://cdn-static.gokick.com/assets/dbba9902646848f8f0b834a64aaa98666d1f7693/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";